module.exports = __webpack_public_path__ + "img/6E.794de913.png";